import React, { useState } from "react";
import {
  useInsertMettingSummary,
  useGetMeetingList,
} from "../../hooks/useManagement";
import { formatDate } from "../../utils/formatDate";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { Table } from "../Table/Table";
import { MeetingsummaryStyle } from "./MeetingsummaryStyle";
import { FaTrash } from "react-icons/fa";
import { DeleteMeetingModal } from "../Dialog/DeleteMeetingModal";
import { MdSystemUpdateAlt } from "react-icons/md";
import { UpdateMeetingModal } from "../Dialog/UpdateMeetingModal";
import { ShowMeetingModal } from "../Dialog/ShowMeetingModal";
import { SelectMulti } from "../MultiSelect/MultiSelect";
import { useGetCompanyUsers } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { errorMessage } from "../../utils/message";
import { useRef } from "react";
const Meetingsummary = () => {
  const [Search, setSearch] = useState("");
  const [meetingId, SetMeetingId] = useState();

  const [item, setItem] = useState();
  const [show, setShow] = useState({
    delete: false,
    update: false,
    meeting: false,
  });

  const { data: customerresponsible, isLoading: responsibleLoading } =
    useGetCompanyUsers();

  const customerResponsible = customerresponsible?.data?.ManagersAndColleagues;

  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });

  const [form, setForm] = useState({
    subject: null,
    description: null,
    date: null,
    target_user: null,
  });
  const { data: meetingsList, isLoading } = useGetMeetingList();

  const MeetingHeaderTitle = [
    "ردیف",
    "موضوع جلسه",
    "متن جلسه",
    "تاریخ جلسه",
    "عملیات",
  ];

  const items = meetingsList?.data?.Meeting?.filter((user) => {
    if (Search === "") {
      return user;
    } else if (user.SubjectMeeting.includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    return (
      <tr key={index}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          {/* <Link to={`/dashboard/crm/customer-file/${item.IdUser}`}> */}
          <span
            className="text-muted fw-bold text-muted d-block fs-7"
            onClick={() => {
              setShow({ ...show, meeting: true });
              setItem(item);
            }}
          >
            {item?.SubjectMeeting}
          </span>
          {/* </Link> */}
        </td>
        <td>
          <span
            className="text-muted fw-bold text-muted d-block fs-7"
            onClick={() => {
              setShow({ ...show, meeting: true });
              setItem(item);
            }}
          >
            {item?.DescriptionMeeting.substring(0, 100)}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.DateMeeting}
          </span>
        </td>
        <td>
          <Button
            bgColor="#f1416c"
            color="#fff"
            small="fit-content"
            onclick={() => {
              SetMeetingId(item.IdMeeting);
              setShow({ ...show, delete: true });
            }}
          >
            <FaTrash color={"#fff"} />
          </Button>
          <Button
            bgColor="#009ef7"
            color="#fff"
            small="fit-content"
            onclick={() => {
              setItem(item);
              setShow({ ...show, update: true });
            }}
            style={{ marginRight: "5px" }}
          >
            <MdSystemUpdateAlt color={"#fff"} />
          </Button>
        </td>
      </tr>
    );
  });
  const validateForm = () => {
    if (form.subject === null || form.subject.length < 1) {
      errorMessage("موضوع صورت جلسه را مشخص کنید");
      return false;
    } else if (form.description === null || form.description.length < 1) {
      errorMessage("متن صورت جلسه را بنویسید");
      return false;
    } else if (form.date === null || form.date.length < 1) {
      errorMessage("تاریخ را مشخص کنید");
      return false;
    } else if (form.target_user === null || form.target_user.length < 1) {
      errorMessage("شخص هدف صورت جلسه را انتخاب کنید");
      return false;
    }
    return true;
  };
  const { mutateAsync: insertMeeting } = useInsertMettingSummary();
  const handleInsert = async (data) => {
    if (validateForm()) {
      await insertMeeting(data).then(() =>
        setForm({ date: null, description: "", subject: "" })
      );
    }
  };
  return (
    <MeetingsummaryStyle className="mt-3">
      <div className="wrapper">
        <div className="row m-0">
          <div className="col-12 head">صورت جلسه</div>
          <div className="row main m-0 px-0">
            <div className="col-lg-4 col-12">
              <InputField1
                placeholder="عنوان"
                label="عنوان"
                onChange={(e) => setForm({ ...form, subject: e.target.value })}
                value={form?.subject}
              />
            </div>
            <div className="col-lg-4 col-12">
              <DataPicker
                onChange={(e) => setForm({ ...form, date: formatDate(e) })}
                label="تاریخ"
              />
            </div>
            <div className="col-lg-4 col-12">
              <SelectMulti
                res={customerResponsibleOptions}
                label="اعضا"
                onChange={(e) =>
                  setForm({
                    ...form,
                    target_user: Array.isArray(e) ? e.map((x) => x.value) : [],
                  })
                }
                // value={}
              />
            </div>
            <div className="col-12 mt-3">
              <SimpleTextArea
                placeholder="صورت جلسه را اینجا بنویسید"
                label="متن صورت جلسه"
                rows="5"
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
                value={form?.description}
              />
            </div>
            <div className="col-12">
              <Button
                bgColor="#009ef7"
                color="#fff"
                small="fit-content"
                size="14px"
                onclick={() => {
                  handleInsert(form);
                }}
              >
                ثبت صورت جلسه
              </Button>
            </div>
          </div>
        </div>
      </div>
      {!isLoading ? (
        <Table
          className="mt-3"
          setSearch={setSearch}
          headerTitle={MeetingHeaderTitle}
          items={items}
          title={`صورت جلسه ها ${meetingsList?.data?.count}`}
        />
      ) : (
        <Loading />
      )}
      <DeleteMeetingModal
        Meeting={meetingId}
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
      />
      <UpdateMeetingModal
        show={show.update}
        handleClose={() => setShow({ ...show, update: false })}
        item={item}
        customerResponsibleOptions={customerResponsibleOptions}
      />
      <ShowMeetingModal
        show={show.meeting}
        handleClose={() => setShow({ ...show, meeting: false })}
        item={item}
      />
    </MeetingsummaryStyle>
  );
};

export default Meetingsummary;
